import { isExternalLink, removeLastSlash } from 'src/routes/utils';

// ----------------------------------------------------------------------

function normalizePath(path) {
  return removeLastSlash(path.split(/[?#]/)[0]);
}

function matchesPath(pathname, searchParams, itemPath, deep) {
  if (!itemPath || itemPath.startsWith('#') || isExternalLink(itemPath)) return false;

  const currentPath = normalizePath(pathname);
  const targetPath = normalizePath(itemPath);
  const [, targetQuery = ''] = itemPath.split('?');
  const pathMatches =
    currentPath === targetPath || (deep && currentPath.startsWith(`${targetPath}/`));

  if (!pathMatches || !targetQuery) return pathMatches;

  const targetSearchParams = new URLSearchParams(targetQuery);

  return Array.from(targetSearchParams.entries()).every(
    ([key, value]) => searchParams.get(key) === value
  );
}

function getMatchScore(pathname, searchParams, item) {
  if (item.children?.length) {
    return Math.max(
      -1,
      ...item.children.map((child) => getMatchScore(pathname, searchParams, child))
    );
  }

  if (!matchesPath(pathname, searchParams, item.path, item.deepMatch === true)) return -1;

  const currentPath = normalizePath(pathname);
  const targetPath = normalizePath(item.path);
  const [, targetQuery = ''] = item.path.split('?');
  const queryCount = Array.from(new URLSearchParams(targetQuery).keys()).length;
  const exactPathBonus = currentPath === targetPath ? 1_000_000 : 0;

  return exactPathBonus + queryCount * 10_000 + targetPath.length;
}

export function findActiveNavItemPath(pathname, searchParams, items = []) {
  let activePath = null;
  let activeScore = -1;

  items.forEach((item) => {
    const score = getMatchScore(pathname, searchParams, item);

    if (score > activeScore) {
      activePath = item.path;
      activeScore = score;
    }
  });

  return activePath;
}

export function hasActiveNavChild(pathname, searchParams, children = []) {
  return children.some(
    (child) =>
      matchesPath(pathname, searchParams, child.path, child.deepMatch === true) ||
      hasActiveNavChild(pathname, searchParams, child.children)
  );
}
